import api from "@/api/trading/apiAccount";
import { formatDecimal } from "@/utils/order";

export default {
  namespaced: true,
  state() {
    return {
      userState: false,
      userWallet: {
        avbl: 0,
        balance: 0,
      },
      userAuth: {
        pmPro: false,
        sm: false,
      },
      reCode: 0,
      unrealizePnl: 0,
      isMobile: false,
      duplicateCheck: false,
    };
  },
  mutations: {
    setUserAuth(state, payload) {
      const userLang = payload.user_lang;
      const totalPrice = payload.package;
      if (
        totalPrice < 3000 &&
        userLang != "MN" &&
        userLang != "VN" &&
        userLang != "MY" &&
        userLang != "ID" &&
        userLang != "IN" &&
        userLang != "PH" &&
        userLang != "TH" &&
        userLang != "CN"
      ) {
        state.userAuth.pmPro = false;
      } else {
        state.userAuth.pmPro = true;
      }

      if (totalPrice < 10000) {
        state.userAuth.sm = false;
      } else {
        state.userAuth.sm = true;
      }
      // console.log('userLang', userLang,'totalPrice', totalPrice,state.userAuth.sm,state.userAuth.pmPro);
    },
    setUserState(state, payload) {
      state.userState = payload;
    },
    setWalletInfo(state, payload) {
      state.userWallet = {
        avbl: formatDecimal(payload.avbl, 4),
        balance: formatDecimal(payload.balance, 4),
      };
    },
    setReCode(state, payload) {
      state.reCode = payload;
    },
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    setDuplicateCheck(state, payload) {
      state.duplicateCheck =
        payload === ""
          ? 0
          : payload === "중복 로그인이 감지되었습니다."
          ? 1
          : 2;
    },
    setUnrealizePnl(state, payload) {
      state.unrealizePnl = formatDecimal(payload, 4);
    },
  },
  actions: {
    async fetchUserState({ commit, rootState  }) {
      try {
        const userNo = rootState.userInfo.userInfo.user_no;
        const response = await api.getUserState(userNo);
        if (response) {
          commit("setUserState", response?.results[0]?.status);
        }
      } catch (error) {
        return;
      }
    },
    async fetchUserWallet({ commit, rootState }) {
      try {
        const userNo = rootState.userInfo.userInfo.user_no;
        const response = await api.getUserWallet(userNo);
        if (response) {
          commit("setWalletInfo", response.results[0]);
        }
      } catch (error) {
        return;
      }
    },
    async postStartTrading({ commit, rootState  }) {
      try {
        const userNo = rootState.userInfo.userInfo.user_no;
        const response = await api.postStartTrading(userNo);
        if (response) {
          commit("setReCode", response.reCode);
        }
      } catch (error) {
        return;
      }
    },
    async postChargeSeed({ commit, rootState }, seed) {
      try {
        const userNo = rootState.userInfo.userInfo.user_no;
        const response = await api.postChargeSeed(userNo, seed);
        if (response) {
          commit("setReCode", response.reCode);
        }
      } catch (error) {
        return;
      }
    },
    async postResetUser({ commit, rootState }) {
      try {
        const userNo = rootState.userInfo.userInfo.user_no;
        const response = await api.postResetUser(userNo);
        if (response) {
          commit("setReCode", response.reCode);
        }
      } catch (error) {
        return;
      }
    },
  },
};
